import { useEffect, useState } from "react"
import loadingImage from "./loading.gif"

export const ImageItem = (props: { file: File }) => {
    const [image, setImage] = useState("")

    useEffect(() => {
        if (image == "") {
            let reader = new FileReader()

            reader.readAsDataURL(props.file)

            reader.onloadend = function (e) {
                if (reader.result instanceof Error) {
                } else if (reader.result instanceof ArrayBuffer) {
                } else {
                    setImage(reader.result!)
                }

            }
        }
    }, [props.file])

    return <div className="card bg-dark border-0 text-white mb-2">
        {image == "" ?
            <img className="card-img" src={loadingImage} style={{ height: "170px" }} />
            :
            <img className="card-img" src={image} alt="Card image" />}
    </div>
}